var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSecurityBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0391 15.7683H10.083C8.54142 15.7683 7.29175 17.0325 7.29175 18.5919V27.0625C7.29175 28.622 8.54142 29.8861 10.083 29.8861H24.0391C25.5806 29.8861 26.8303 28.622 26.8303 27.0625V18.5919C26.8303 17.0325 25.5806 15.7683 24.0391 15.7683Z",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.061 24.2391C17.8318 24.2391 18.4566 23.607 18.4566 22.8273C18.4566 22.0476 17.8318 21.4155 17.061 21.4155C16.2902 21.4155 15.6654 22.0476 15.6654 22.8273C15.6654 23.607 16.2902 24.2391 17.061 24.2391Z",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4786 15.7684V10.1212C11.4786 8.62353 12.0667 7.18716 13.1136 6.12812C14.1605 5.06908 15.5805 4.47412 17.061 4.47412C18.5416 4.47412 19.9615 5.06908 21.0084 6.12812C22.0553 7.18716 22.6435 8.62353 22.6435 10.1212V15.7684",
    stroke: "#0C6CDE",
    strokeWidth: 2.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurityBlue);
export default __webpack_public_path__ + "static/media/Icon_Security_Blue.7c798fa06fa374731fd53bb20a027fac.svg";
export { ForwardRef as ReactComponent };